import API from './API.js'

export default class Results extends API {
  constructor() {
    super('results')
  }
}
